module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "section"
    }
  }, [_c('el-row', {
    staticClass: "statusRow"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": _vm.createBillData
    }
  }, [_vm._v("生成账单")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createBillDataOne()
      }
    }
  }, [_vm._v("批量生成账单")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createBillDataALl(0)
      }
    }
  }, [_vm._v("一键批量生成账单")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择公司名称"
    },
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1), _vm._v("\n       账单周期：   \n\t\t  "), _c('el-date-picker', {
    attrs: {
      "type": "monthrange",
      "range-separator": "至",
      "start-placeholder": "开始月份",
      "end-placeholder": "结束月份",
      "format": "yyyy 年 MM 月",
      "value-format": "yyyyMM"
    },
    on: {
      "change": _vm.monthValChange
    },
    model: {
      value: (_vm.monthVal),
      callback: function($$v) {
        _vm.monthVal = $$v
      },
      expression: "monthVal"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择结算账单周期",
      "clearable": ""
    },
    model: {
      value: (_vm.pdata.stype),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "stype", $$v)
      },
      expression: "pdata.stype"
    }
  }, [_c('el-option', {
    key: "1",
    attrs: {
      "label": "周",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "label": "半月",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "3",
    attrs: {
      "label": "月",
      "value": "3"
    }
  })], 1), _vm._v(" "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择发票类型",
      "clearable": ""
    },
    model: {
      value: (_vm.pdata.invoice_type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "invoice_type", $$v)
      },
      expression: "pdata.invoice_type"
    }
  }, [_c('el-option', {
    key: "1",
    attrs: {
      "label": "普通发票",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "label": "增值税发票",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "15px 15px 55px 15px",
      "background": "#fff"
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.pdata.status),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "status", $$v)
      },
      expression: "pdata.status"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "未对账",
      "name": "0"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已核对",
      "name": "1"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "开票中",
      "name": "2"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "待收款",
      "name": "3"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已收款",
      "name": "4"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已作废",
      "name": "-1"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticClass: "demo-table",
    staticStyle: {
      "width": "100%",
      "min-width": "1200px"
    },
    attrs: {
      "data": _vm.plist,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": 710
    },
    on: {
      "selection-change": _vm.select
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "min-width": "30px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID",
      "min-width": "50px",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "company_name",
      "label": "公司名称",
      "align": "center",
      "min-width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bill_sdate",
      "label": "结算日期",
      "min-width": "120px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.bill_sdate) + "~" + _vm._s(scope.row.bill_edate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "stype",
      "label": "结算周期",
      "min-width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.stype == 1) ? _c('span', [_vm._v("周结")]) : (scope.row.stype == 2) ? _c('span', [_vm._v("半月结")]) : (scope.row.stype == 3) ? _c('span', [_vm._v("月结")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bill_amount",
      "label": "结算金额",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.bill_amount - 0) - (b.bill_amount - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "导量人数",
      "min-width": "50px",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.num - 0) - (b.num - 0)
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invoice_type",
      "label": "发票类型",
      "min-width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.invoice_type == 1 ? '普通发票' : '增值发票'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "结算类型",
      "min-width": "50px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 1) ? _c('span', [_vm._v("对公")]) : (scope.row.type == 2) ? _c('span', [_vm._v("对私")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bill_amount_offset",
      "label": "抵扣后金额",
      "min-width": "60px",
      "align": "center",
      "sortable": "",
      "sort-method": function (a, b) {
        return (a.bill_amount_offset - 0) - (b.bill_amount_offset - 0)
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.bill_amount_offset > 0) ? _c('span', [_vm._v(_vm._s(scope.row.bill_amount_offset))]) : _c('span', [_vm._v("0")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "offset",
      "label": "是否抵扣",
      "min-width": "60px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.offset == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.billOffset(scope.row, 1)
            }
          }
        }, [_vm._v("否")]) : _vm._e(), _vm._v(" "), (scope.row.offset == 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.billOffset(scope.row, 0)
            }
          }
        }, [_vm._v("是")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "min-width": "80px",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.groupid == 0 || _vm.groupid == 1) ? _c('div', [(scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("未对账")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已核对")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("开票中")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("待收款")]) : _vm._e(), _vm._v(" "), (scope.row.status == 4) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已收款")]) : _vm._e(), _vm._v(" "), (scope.row.status == -1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已作废 ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.groupid == 4) ? _c('div', [(scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("未对账")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已核对")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("开票中")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("待收款")]) : _vm._e(), _vm._v(" "), (scope.row.status == 4) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("已收款")]) : _vm._e(), _vm._v(" "), (scope.row.status == -1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "info"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已作废 ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.groupid == 13) ? _c('div', [(scope.row.status == 0) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("未对账")]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("已核对")]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          }
        }, [_vm._v("开票中")]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("待收款")]) : _vm._e(), _vm._v(" "), (scope.row.status == 4) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已收款")]) : _vm._e(), _vm._v(" "), (scope.row.status == -1) ? _c('el-button', {
          attrs: {
            "size": "mini",
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.billEdit(scope.row)
            }
          }
        }, [_vm._v("已作废 ")]) : _vm._e()], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "操作",
      "min-width": "50px",
      "width": "400",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium",
            "type": "primary",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.updateBillData(scope.row)
            }
          }
        }, [_vm._v("更新账单")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.$router.push({
                name: '账单详情明细',
                params: {
                  index_id: scope.row.id
                },
                query: {
                  bill_date: scope.row.bill_date
                }
              })
            }
          }
        }, [_vm._v("明细")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.openDealy(scope.row.id)
            }
          }
        }, [_vm._v("操作日志")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "pageRow"
  }, [_c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80, 200],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '账单生成' : '账单生成',
      "visible": _vm.editDialog,
      "top": "5vh",
      "width": "750px",
      "custom-class": "dialog",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "gutter": 5
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择结算公司"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "multiple": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.chooseCompany),
      callback: function($$v) {
        _vm.chooseCompany = $$v
      },
      expression: "chooseCompany"
    }
  }, _vm._l((_vm.companyList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.buildBillData
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isAdd ? '结算' : '结算',
      "visible": _vm.billDialog,
      "top": "5vh",
      "width": "950px",
      "custom-class": "dialog",
      "close-on-click-modal": false,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.billDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.chooseProduct,
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('div', {
    staticClass: "el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "ta"
    }
  }, [_c('div', {
    staticClass: "el-table__header-wrapper"
  }, [_c('table', {
    staticClass: "el-table__header",
    staticStyle: {
      "width": "900px"
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0",
      "id": "ta"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_29",
      "width": "160"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_30",
      "width": "120"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_31",
      "width": "120"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_32",
      "width": "70"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_33",
      "width": "80"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_34",
      "width": "80"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_35",
      "width": "135"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "el-table_3_column_28_column_36",
      "width": "135"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "name": "gutter",
      "width": "0"
    }
  })]), _vm._v(" "), _c('thead', {
    staticClass: "is-group has-gutter"
  }, [_c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28  is-center  ",
    attrs: {
      "colspan": "8",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算对账单")])])]), _vm._v(" "), _c('tr', {}, [_c('th', {
    staticClass: "el-table_3_column_28_column_29  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("结算周期")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_30  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("游戏名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_31  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("渠道名称")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_32  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("平台")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_33  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("合作方式")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_34  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("新增人数")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_35  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("单价（元/个）")])]), _vm._v(" "), _c('th', {
    staticClass: "el-table_3_column_28_column_36  is-center   is-leaf",
    attrs: {
      "colspan": "1",
      "rowspan": "1"
    }
  }, [_c('div', {
    staticClass: "cell"
  }, [_vm._v("应收金额（￥）")])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "el-table__body"
  }, [_vm._l((_vm.billList), function(item, index) {
    return _c('tr', {
      staticClass: "el-table__row",
      class: index % 2 == 1 ? 'el-table__row--striped' : ''
    }, [_c('td', {
      staticClass: "el-table_3_column_28_column_29 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_c('span', [_vm._v(_vm._s(item.bill_sdate) + "~" + _vm._s(item.bill_edate))])])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_30 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.product_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_31 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.channel_name))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_32 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.platform))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_33 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.type))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_34 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.num))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_35 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.unit))])]), _vm._v(" "), _c('td', {
      staticClass: "el-table_3_column_28_column_36 is-center ",
      attrs: {
        "rowspan": "1",
        "colspan": "1"
      }
    }, [_c('div', {
      staticClass: "cell"
    }, [_vm._v(_vm._s(item.amount))])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "8"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算类型\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.company.type == 1 ? '企业' : '个人') + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("发票类型\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.bill.invoice_type == 1 ? '普通发票' : '增值发票') + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("新增用户\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.bill.num) + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("税点\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.bill.tax_point) + "%\t")])]), _vm._v(" "), (_vm.bill.offset == 1) ? _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("抵扣金额\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "5"
    }
  }, [_vm._v(_vm._s(_vm.bill.offset_amount) + "\t")])]) : _vm._e(), _vm._v(" "), _c('tr', [(_vm.company.type == 1) ? _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算金额\t")]) : _vm._e(), _vm._v(" "), (_vm.company.type == 2) ? _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算金额(扣去税点后金额)\t")]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.bill.bill_amount) + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("结算金额（人民币大写）\t")]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.bill.big_bill_amount) + "\t")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "8"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("甲方公司 ：" + _vm._s(_vm.company.name))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[0]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("税号：" + _vm._s(_vm.company.social_credit_code))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[3]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("注册地址：" + _vm._s(_vm.company.company_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[4]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("注册电话：" + _vm._s(_vm.company.company_phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[8]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("开户银行 ：" + _vm._s(_vm.company.opening_bank))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[1]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("银行 账号：" + _vm._s(_vm.company.receiving_account))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[2]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("联系人：" + _vm._s(_vm.company.contact))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[6]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("联系电话：" + _vm._s(_vm.company.phone))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[7]))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v("邮寄地址：" + _vm._s(_vm.company.email_addr))]), _vm._v(" "), _c('td', {
    staticClass: "el-table_3_column_28_column_36 is-center ",
    attrs: {
      "rowspan": "1",
      "colspan": "4"
    }
  }, [_vm._v(_vm._s(_vm.wecompany[5]))])])], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.bill.status == 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 1)
      }
    }
  }, [_vm._v("确认对账")]) : _vm._e(), _vm._v(" "), (_vm.bill.status == 1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 2)
      }
    }
  }, [_vm._v("确认核对")]) : _vm._e(), _vm._v(" "), (_vm.bill.status == 2) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 3)
      }
    }
  }, [_vm._v("确认开票")]) : _vm._e(), _vm._v(" "), (_vm.bill.status == 3) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 4)
      }
    }
  }, [_vm._v("确认付款")]) : _vm._e(), _vm._v(" "), (_vm.bill.status == -1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, 0)
      }
    }
  }, [_vm._v("确认恢复")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.ChangeBillDataStatus(_vm.bill.id, -1)
      }
    }
  }, [_vm._v("作废")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.tableToExcel
    }
  }, [_vm._v("导出Excel")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.billDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更新日志",
      "visible": _vm.logDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.logDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.plog
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "username",
      "label": "操作人员",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "备忘"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7529a2d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/company/dataList.vue
// module id = 1110
// module chunks = 2